export const modalWarningCloseTask = {
    view: function (ctrl, args) {

        return m('div.dm-overlay',
            m("div.dm-table", [
                m("div.dm-cell", [
                    m("div.dm-modal", [
                        m(".bg-primary[style='padding:10px;z-index:1;']", [
                            m("span[id='modalTitleCloseTask'][style='margin-right: 15px']", "[Title]"),
                            m("span.pull-right[style='cursor: pointer;']", {
                                onclick: modalContainerWarningCloseTask.close
                            }, [
                                m("i.glyphicon.glyphicon-remove"),
                                m.trust('&nbsp;Закрыть')
                            ])
                        ]),
                        [
                            m("div", [
                                m("div[style='margin: 15px 0; padding: 0 15px;']", [
                                    m("div[style='']", [
                                        m("div[id='modalContentCloseTask'][style='text-align: center']", "[Content]"),
                                            m(".row[style='text-align: center; margin-top: 15px']", [
                                                m("button.btn.btn-warning.btn-lg", {
                                                    //id: "",
                                                    onclick: function () {
                                                        modalContainerWarningCloseTask.close();
                                                    }
                                                }, "Ок")
                                            ]),
                                    ]),
                                ])
                            ])
                        ]
                    ])
                ])
            ])
        );
    }
};

export const modalContainerWarningCloseTask = {
    container: null,
    idElement: null,
    init: function () {
        modalContainerWarningCloseTask.container = document.querySelector('#modalWarningCloseTask');
        if (!modalContainerWarningCloseTask.container) {
            modalContainerWarningCloseTask.container = document.createElement('div');
            modalContainerWarningCloseTask.container.id = 'modalWarningCloseTask';
            modalContainerWarningCloseTask.container.hidden = true;
            document.body.appendChild(modalContainerWarningCloseTask.container);

            m.mount(modalContainerWarningCloseTask.container, m.component(modalWarningCloseTask, {data:  "", type: false, idElement: ""}));
        }
    },
    open: function (title, message, buttons= null, idElement = null) {
        modalContainerWarningCloseTask.container = document.querySelector('#modalWarningCloseTask');
        if(typeof(idElement) != "undefined" && idElement !== null)
            modalContainerWarningCloseTask.idElement = idElement;
        if(typeof(removeAll) != "undefined" && removeAll !== null)
            modalContainerWarningCloseTask.removeAll = removeAll;

        if (modalContainerWarningCloseTask.container) {
            if(title){
                document.getElementById("modalTitleCloseTask").innerHTML = title;
            }
            if(message){
                document.getElementById("modalContentCloseTask").innerHTML = message;
            }
            /*if(buttons){
                document.getElementById("modalButtons").innerHTML = "";
                document.getElementById("modalButtons").append(buttons);
            }*/


            modalContainerWarningCloseTask.container.hidden = false;
        }
    },
    close: function () {
        modalContainerWarningCloseTask.container.hidden = true;
    }
};
